import cx from 'classnames';
import { useHasSoftPull } from '~/contexts/FinanceAndTradeContext';
import { usePriceTerms } from '../hooks';

export default function MonthlyPayment(): JSX.Element | null {
  const { monthlyPayment = 0, hasTerms } = usePriceTerms();
  const hasValidMonthlyPayment = monthlyPayment > 0;
  const hasValidSoftPull = useHasSoftPull();

  return hasTerms ? (
    <div
      data-qa="monthly-payment"
      className={cx('flex gap-4', {
        empty: !hasValidMonthlyPayment
      })}
    >
      {hasValidSoftPull ? null : 'Estimated '}${monthlyPayment}/mo
    </div>
  ) : null;
}
